export default __webpack_public_path__ + "static/privacy-img-e8926953c4d236810194fe79688a64ed.png";